
const namespaced = true

const state = {
	pc_token: '',
    positions: []
}

const getters = {

}

const mutations = {
	pc_token (state, pc_token) {
        state.pc_token = pc_token
        localStorage.setItem('pc_token', pc_token)
    },
    position (state, payload) {
        state.positions[payload.name] = payload.position
    }
}

const actions = {
    setToken({ commit, dispatch, state }, pc_token) {
        commit('pc_token', pc_token)
        axios.defaults.headers.common = {
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': `Bearer ${pc_token}`,
        }
        // if(!state.user)
            // dispatch('getUser')
    },
}

export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/param.js